
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection-rankings",
      function () {
        return require("private-next-pages/collection-rankings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection-rankings"])
      });
    }
  